export default "__VITE_ASSET__CAldQmSB__"